import { connect } from "react-redux";
import React, { Component } from "react";
import axios from "axios";
import "antd/lib/select/style/index.css";
import "antd/lib/date-picker/style/index.css";
import "antd/lib/input/style/index.css";
import "antd/lib/radio/style/index.css";
import "antd/lib/switch/style/index.css";
import "antd/lib/checkbox/style/index.css";
import "antd/lib/form/style/index.css";
import urlParameterHelper from "../../../utilities/urlParameters";

class Pagination extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFetching: false,
      results: [],
      pageNumbers: [],
      currentPage: this.props.search.page,
      lastPage: null,
      pagination: [],
      initPageRange: this.props.search.page < 3 ? 1 : 3,
      maxPageRange: 8
    };
  }

  componentDidMount() {
    const pageNumbers = [];

    for (
      let i = 1;
      i <=
      Math.ceil(this.props.search.total_records / this.props.search.pageSize);
      i++
    ) {
      pageNumbers.push(i);
    }
    const pagination = [];

    this.setState({
      ...this.state,
      pageNumbers: pageNumbers,
      currentPage: this.props.search.page,
      lastPage: pageNumbers[pageNumbers.length - 1],
      pagination
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.options && this.state.isFetching === false && this.state.results.length < 1 || (prevProps.options !== this.props.options)) {
      this.callDownloadAPI();
    }
  }

  callDownloadAPI() {
    this.setState({
      isFetching: true
    });
    const optionsQuery = urlParameterHelper.stringify(this.props.options);
    axios.get(`api/v1/hwts/search/all/csv?${optionsQuery}`)
      .then(results => {
        if (results.data.length > 0) {
          this.setState({
            results: results.data,
            isFetching: false,
          });
        } else {
          this.setState({
            isFetching: false
          });
        }
      })
  }
  onNextPageChange = () => {
    const nextPage = this.props.search.page + 1;
    this.props.onPageChange({ page: nextPage });
  };

  onPreviousPageChange = () => {
    const nextPage = this.props.search.page - 1;
    this.props.onPageChange({ page: nextPage });
  };

  getPageNumber = () => {
    let pageNumbers = [];

    for (
      let i = 1;
      i <=
      Math.ceil(this.props.search.total_records / this.props.search.pageSize);
      i++
    ) {
      pageNumbers.push(i);
    }
    const pagination = [];

    return pageNumbers;
  };

  getCurrentPage = () => {
    return this.props.search.page;
  };

  getInitPageRange = () => {
    return this.props.search.page < 3 ? 1 : 3;
  };

  getLastPage = () => {
    let lastPage = this.getPageNumber().length - 1;
    return lastPage;
  };

  render() {
    const { page } = this.props.search;
    const {
      currentPage,
      pageNumbers,
      lastPage,
      initPageRange,
      maxPageRange
    } = this.state;

    const style = {
      active: {
        backgroundColor: "#046B99",
        color: "white"
      }
    };

    const pagination = this.getPageNumber()
      .map(page => (
        <li className="page-item" key={page}>
          <a
            style={this.getCurrentPage() == page ? style.active : {}}
            className="page-link"
            onClick={() => this.props.onPageChange({ page: page })}
          >
            {page}
          </a>
        </li>
      ))
      .splice(this.getCurrentPage() - this.getInitPageRange(), 8);

    if (this.props.search.total_records === 0) {
      return <div />;
    }

    return (
      <div style={{ textAlign: "center" }}>
        <nav aria-label="">
          <ul className="pagination justify-content-center">
            <li className={page === 1 ? "page-item disabled" : "page-item"}>
              <a
                className="page-link"
                onClick={
                  page === 1 ? null : () => this.props.onPageChange({ page: 1 })
                }
                tabIndex="-1"
              >
                First
              </a>
            </li>
            <li className={page === 1 ? "page-item disabled" : "page-item"}>
              <a
                className="page-link"
                onClick={page === 1 ? null : this.onPreviousPageChange}
                tabIndex="-1"
              >
                Previous
              </a>
            </li>
            {pagination}
            <li
              className={
                page == lastPage || page == this.getLastPage() + 1
                  ? "page-item disabled"
                  : "page-item"
              }
            >
              <a
                className="page-link"
                onClick={page === lastPage ? null : this.onNextPageChange}
              >
                Next
              </a>
            </li>
            <li
              className={
                page == this.getLastPage() + 1
                  ? "page-item disabled"
                  : "page-item"
              }
            >
              <a
                className="page-link"
                onClick={
                  page === this.getLastPage() + 1
                    ? null
                    : () =>
                      this.props.onPageChange({
                        page: this.getLastPage() + 1
                      })
                }
              >
                Last
              </a>
            </li>
          </ul>
          {this.state.results.length > 0 ?
            <div style={{ textAlign: 'left', width: '100%' }}>
              {/* <CSVLink data={this.state.results}>
                <button type="submit" className="ca-gov-icon-attachment" style={{ position: 'relative', height: '35px', width: '50px', top: '-53px', fontSize: '1.5em' }}></button>
              </CSVLink> */}
            </div>
            : ''}
        </nav>
        {/* Page: {currentPage} of {pageNumbers.length} */}
        Page: {this.getCurrentPage()} of{" "}
        {Math.ceil(
          this.props.search.total_records / this.props.search.pageSize
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  search: state.search.options
});

export default connect(mapStateToProps, {})(Pagination);

// export default Pagination;
